module.exports = __webpack_public_path__ + "static/img/morenimg.c799098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/morenimg.png
// module id = GHUV
// module chunks = 10